module.exports = {"141023100":"新城镇","141023101":"赵康镇","141023102":"汾城镇","141023103":"南贾镇","141023104":"古城镇","141023105":"襄陵镇","141023106":"邓庄镇","141023200":"陶寺乡","141023201":"永固乡","141023202":"景毛乡","141023203":"西贾乡","141023204":"南辛店乡","141023205":"大邓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141023.json
// module id = 322
// module chunks = 0